import { render, staticRenderFns } from "./ContactInformationAdditionalConsents.vue?vue&type=template&id=077ccf1c&scoped=true&"
import script from "./ContactInformationAdditionalConsents.vue?vue&type=script&lang=ts&"
export * from "./ContactInformationAdditionalConsents.vue?vue&type=script&lang=ts&"
import style0 from "./ContactInformationAdditionalConsents.vue?vue&type=style&index=0&id=077ccf1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077ccf1c",
  null
  
)

export default component.exports